module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullnameChangePanel"
    }
  }, [_c('span', [_vm._v("氏名の変更")]), _vm._v(" "), _c('label', [_vm._v("新しい氏名:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_fullname),
      expression: "new_fullname"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_fullname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("新しいフリガナ:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_kana),
      expression: "new_kana"
    }],
    attrs: {
      "type": "text",
      "name": "kana"
    },
    domProps: {
      "value": (_vm.new_kana)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_kana = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.changeFullnameLocal
    }
  }, [_vm._v("氏名を変更")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-201dfa4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo/FullnameChangePanel.vue
// module id = 677
// module chunks = 0